import translate from "src/functions/translate";
import { useRouter } from "next/router";

type Props = { tKey: string };

function Translate({ tKey }: Props) {
  const { locale: lang } = useRouter();
  var translated = translate(tKey, lang || "en");
  return translated;
}

export default Translate;
